import { Component } from "@angular/core";
import { MainStore } from "../../../store/main-store";
import { GlobalService } from "../../services/global.service";
import { AsociadoModel } from "../../models/datosAsociado";
import { Router } from "@angular/router";
import { AddressesUrlParams } from "../../../parameters/addresses-url-params";
import { SAlertComponent } from "../../components/s-alert/s-alert.component";
import { Utils } from "../../../utils/utils";

@Component({
  selector: "pages-top",
  templateUrl: "./pages-top.component.html",
  styleUrls: ["./pages-top.component.scss"]
})
export class PagesTopComponent {
  avatarImgSrc: string = "assets/images/logotipo.png";
  titImgSrc: string = "assets/images/tit_covid-19.png";
  headImgSrc: string = "assets/images/img_Senhor.png";
  

  sidebarToggle: boolean = false;
  tip = { ring: true, email: true };

  constructor(private _globalService: GlobalService, private route: Router) {
    
  }

  /**
   * @author Jose Wilson Mulato
   * @description envia abrir o cerrar el menu
   */
  public _sidebarToggle() {
    this._globalService.data$.subscribe(
      data => {
        if (data.ev === "sidebarToggle") {
          this.sidebarToggle = data.value;
        }
      },
      error => {

      }
    );
    this._globalService.dataBusChanged("sidebarToggle", !this.sidebarToggle);
  }

  /**
     * @author Jose Wilson Mulato
     * @description envia abrir o cerrar el menu
     */
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layouts/pages-top/pages-top.component.ts